import { toast } from "react-toastify";

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function compareJson(json1, json2) {
  let invalidKeys = [];

  function compareKeys(obj1, obj2, parentKey = "") {
    if (
      typeof obj1 !== "object" ||
      typeof obj2 !== "object" ||
      obj1 === null ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    for (let key of keys1) {
      let fullKey = parentKey ? `${parentKey}.${key}` : key;

      if (!keys2.includes(key)) {
        invalidKeys.push(fullKey);
      } else if (
        typeof obj1[key] === "object" &&
        typeof obj2[key] === "object" &&
        obj1[key] !== null &&
        obj2[key] !== null
      ) {
        compareKeys(obj1[key], obj2[key], fullKey);
      } else if (
        (typeof obj1[key] === "object" && obj1[key] !== null) ||
        (typeof obj2[key] === "object" && obj2[key] !== null)
      ) {
        invalidKeys.push(fullKey);
      }
    }
  }

  if (typeof json1 !== "object" || !json1 || typeof json2 !== "object" || !json2) {
    return ["invalid json"];
  }

  if(Object.keys(json1).length === 0 || Object.keys(json2).length === 0) {
    return ["empty json"];
  }

  compareKeys(json1, json2);
  return invalidKeys;
}

export function isValidJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function decodeHtmlEntities(text) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
}

export function pathExistsInObject(obj, path) {
  const parts = path?.split(".");
  let current = obj;
  for (const part of parts) {
    if (
      current?.[part] === undefined ||
      current?.[part] === null ||
      current?.[part] === false ||
      current?.[part] === ""
    ) {
      return false;
    }
    current = current[part];
  }
  return true;
}

// {{AS_AUDIENCE_ID_FULL}}: dexata-sandbox_main_107
// {{AS_AUDIENCE_ID_NUMERIC}}: 107
// {{AS_AUDIENCE_NAME}} : Window Shopper
// AS_DLE_{{AS_AUDIENCE_ID_NUMERIC}}_{{AS_AUDIENCE_NAME}} then the value will be AS_DLE_107_Window Shopper
export function generateTeliumAudienceStreadName(
  naming_convention,
  audienceId,
  audienceName
) {
  const getIdInNumeric = audienceId.split("_").at(-1);

  return naming_convention
    .replaceAll("{{AS_AUDIENCE_ID_FULL}}", audienceId)
    .replaceAll("{{AS_AUDIENCE_ID_NUMERIC}}", getIdInNumeric)
    .replaceAll("{{AS_AUDIENCE_NAME}}", audienceName);
}

export function findPathAndUpdateValue(obj, path, newValue) {
  const keys = path.split(/[\.\[\]]/).filter(Boolean);
  let value = obj;
  let parent = null;
  let key = null;

  for (const k of keys) {
    if (value[k] === undefined) {
      return undefined;
    }
    parent = value;
    key = k;
    value = value[k];
  }

  if (newValue !== undefined) {
    parent[key] = newValue;
    return { updatedObj: obj, updatedValue: newValue };
  }

  return value;
}

export function getValueByPathFromObj(obj, path) {
  if (!obj || !path) return undefined;

  const keys = path.split(".");
  let current = obj;

  for (let key of keys) {
      if (current[key] === undefined) {
          return undefined;
      }
      current = current[key];
  }

  return current;
}

export const updateHtmlTemplate = (htmlTemplate, fieldValues) => {
  const replacePlaceholders = (template, data) => {
    return template.replace(/\${template\.(.*?)}/g, (match, p1) => {
      return data[p1] !== undefined ? data[p1] : match;
    });
  };

  const transformedValues = {};
  Object.keys(fieldValues).forEach((key) => {
    const newKey = key.replace(/\./g, ".");
    transformedValues[newKey] = fieldValues[key];
  });

  const updatedHTML = replacePlaceholders(htmlTemplate, transformedValues);
  return updatedHTML;
};

export function addExperienceIdToHTML(htmlString, experienceId, versionNo) {
    if(!experienceId || (typeof htmlString !== "string")) return htmlString;
    return htmlString.replace(
        /(['"]experience_id['"]\s*:\s*['"])[^'"]*(['"])/,
        `$1${experienceId}-${versionNo}$2`
    );
}

export const getObjFromHtml = (html, config_obj_key) => {
  if (typeof html !== 'string' || !html) {
    return null;
  }
  const regex = new RegExp(`var ${config_obj_key}\\s*=\\s*({[\\s\\S]*?});`);
  const match = html.match(regex);
  // match(/var config_v1\s=\s({[\s\S]*?});/);

  if (match && match[1]) {
    try {
      let jsonString = match[1];

      // if (jsonString.trim().endsWith(",")) {
      //   jsonString = jsonString.slice(0, -1);
      // }

      const obj = JSON.parse(jsonString);
      return obj;
    } catch (error) {
      console.error("Failed to parse config_banner_v1 object:", error);
      toast.error("Invalid JSON of HTML.")
      return null;
    }
  } else {
    console.error(`${config_obj_key} not found`);
    return null;
  }
};

export const updateObjInHtml = (html, config_obj_key, config_obj) => {
  const regex = new RegExp(`var ${config_obj_key}\\s*=\\s*({[\\s\\S]*?});`);
  const match = html.match(regex);

  if (match) {
    try {
      const temp = html.replace(regex, `var ${config_obj_key} = ${config_obj};`);
      return temp;
    } catch (error) {
      console.error("Failed to parse config_banner_v1 object:", error);
      return null;
    }
  } else {
    console.error(`${config_obj} not found`);
    return null;
  }
};

export const checkObjFromHtml = (html) => {
  if (typeof html !== 'string' || !html) {
    return null;
  }
  const match = html.match(/var config_banner_v1\s=\s({[\s\S]*?});/);

  if (match) {
    return true;
  } else {
    return false;
  }
};

export const transformExperienceJSON = (fieldValues, dynamicFields) => {
  const transformed = {};
  for (const key in fieldValues) {
    if (fieldValues.hasOwnProperty(key)) {

      const keys = key.split('.');
      let current = transformed;
      for (let i = 0; i < keys.length; i++) {
        const nestedKey = keys[i];
        if (i === keys.length - 1) {

          if(dynamicFields[key] !== undefined) {
            current[nestedKey] = dynamicFields[key];
          } else {
            current[nestedKey] = fieldValues[key];
          }

        } else {
          current = current[nestedKey] || (current[nestedKey] = {});
        }
      }
    }
  }
  return transformed;
}

export const formatCSVData = (data) => {
  if (!data || data.length < 2) return []; // Ensure data has at least a header and one row
  
  const headers = data[0]; // First object as keys
  const formattedArray = [];

  // Iterate through the data starting from the second element
  for (let i = 1; i < data.length; i++) {
      const currentRow = data[i];
      const formattedRow = {};

      // Map keys (headers) to values for the current row
      Object.keys(headers).forEach((key) => {
          const headerKey = headers[key]; // Extract key from header row
          formattedRow[headerKey] = currentRow[key]; // Assign corresponding value
      });

      formattedArray.push(formattedRow); // Add the formatted row to the result array
  }

  return formattedArray;
};

export const validateFlattenJson = (config, data) => {
  const errors = [];

  for (let i = 0; i < data.length; i++) {
    const element = data[i];

    config.forEach((field) => {
      const { rules, input } = field;
      const value = element[input.input_label];

      if (rules.is_mandatory && (value === undefined || value === null || value === '')) {
        errors.push(`${input.input_label} in row ${i+1} is mandatory`);
      }

      if (rules.min_length && value && `${value}`.length < rules.min_length) {
        errors.push(`Minimum length of ${input.input_label} in row ${i+1} is ${rules.min_length}`);
      }

      if (rules.max_length && value && `${value}`.length > rules.max_length) {
        errors.push(`Maximum length of ${input.input_label} in row ${i+1} is ${rules.max_length}`);
      }
    });

  }
  return errors;
};

export const generateStepContent = (contentText = "") => (
  <div id="popup-for-tour-create-exp" className="text-center z-[10000]">
    <p className="text-gray-600">{contentText}</p>
  </div>
);

export const getFlattenExperienceJSON = (ob, arrayFields = {}) => {
  let result = {};
  function recurse(cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      if(arrayFields[prop]) {
        result[prop] = cur;
      } else {
        for (let i = 0; i < cur.length; i++) {
          recurse(cur[i], prop ? prop + "[" + i + "]" : i);
        }
      }
      if (cur.length === 0) result[prop] = [];
    } else {
      let isEmpty = true;
      for (let p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop + "." + p : p);
      }
      if (isEmpty && prop) result[prop] = {};
    }
  }
  recurse(ob, "");
  return result;
}

export const formattedTemplateName = (str) => {
  return str
      .toLowerCase() // Convert to lowercase
      .replace(/\s*-\s*/g, "-") // Remove spaces around existing hyphens
      .replace(/\s+/g, "-") // Replace remaining spaces with hyphens
      .replace(/[^\w-]/g, "") // Remove non-alphanumeric characters except hyphens
      .replace(/-+/g, "-") // Ensure no multiple hyphens in a row
      .trim(); // Remove leading/trailing hyphens if any
};

export const getNestedData = (obj, path) => {
  const keys = path.split('.'); // Split the path into keys
  let result = obj;

  for (let key of keys) {
    if (result && result.hasOwnProperty(key)) {
      result = result[key];
    } else {
      return undefined; // Return undefined if path doesn't exist
    }
  }
  return result;
};

// Helper to get nested property from object using dot/bracket notation
function getNested(obj, path) {
  const parts = path.split('.').flatMap(part =>
    part.includes('[')
      ? part.split(/[\[\]]/).filter(Boolean)
      : part
  );

  return parts.reduce((acc, key) => {
    if (acc === undefined || acc === null) return undefined;
    return isNaN(key) ? acc[key] : acc[Number(key)];
  }, obj);
}

// Main function to check exp_json_fields
function checkMissingFields(template, config) {
  const missing = [];
  config.forEach(({ exp_json_field }) => {
    const value = getNested(template, exp_json_field);
    if (value === undefined) {
      missing.push(exp_json_field);
    }
  });
  return missing;
}

/**
 * Identify template type based on JSON Schema and Config JSON
 * @param {Object} jsonSchema - The JSON schema object
 * @param {Array} configJson - The configuration JSON array
 * @returns {"json-a-to-a" | "json-a-to-b"}
 */
function detectTemplateType(jsonSchema, configJson) {
  const allSchemaPaths = getAllKeyPaths(jsonSchema);
  const configPaths = configJson.map(c => c.exp_json_field);

  // Check if every schema path is present in config JSON
  const allPathsExist = allSchemaPaths.every(path => configPaths.includes(path));

  return allPathsExist ? "json-a-to-a" : "json-a-to-b";
}

/**
 * Recursively extract all key paths from a JSON object
 * @param {Object} obj - The object to extract paths from
 * @param {string} prefix - Used internally for recursion
 * @returns {string[]} - List of all key paths
 */
function getAllKeyPaths(obj, prefix = "") {
  let paths = [];

  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    const newPath = prefix ? `${prefix}.${key}` : key;

    if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
      paths = paths.concat(getAllKeyPaths(obj[key], newPath));
    } else {
      paths.push(newPath);
    }
  }

  return paths;
}

export const findTemplateType = (enums, templateData) => {
  if(!templateData) return 

  if(!templateData?.html && !templateData?.css) {
    return enums.templateTypes.no_preview.id;
  }

  const configObjKey = JSON.parse(templateData.json_schema)?.config_obj_key;

  if(configObjKey) {
    const configObjFromHtml = getObjFromHtml(templateData?.html, configObjKey);

    if (configObjFromHtml) {
      return enums.templateTypes.json_a_to_html.id;
    }
    // const tempJson = JSON.parse(templateData?.json_schema);
    // delete tempJson?.config_obj_key;

    // const keyDiffsInJson = compareJson(configObjFromHtml, tempJson);
    // if (keyDiffsInJson?.length == 0) {
    //   return enums.templateTypes.json_a_to_html.id;
    // } else {
    //   return "NO FOUND"
    // }
  } else {
    const templateType = detectTemplateType(JSON.parse(templateData?.json_schema), JSON.parse(templateData?.config_json));
    if(templateType === "json-a-to-a") {
      return enums.templateTypes.json_a_to_a.id;
    } else {
      return enums.templateTypes.json_a_to_b.id;
    }
  }
}

export function xmlToJsonSimplified(xml) {
  let obj = {};

  if (xml.nodeType === 1) { // element
    // Add attributes as direct properties
    if (xml.attributes.length > 0) {
      for (let j = 0; j < xml.attributes.length; j++) {
        let attribute = xml.attributes.item(j);
        obj[attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType === 3 || xml.nodeType === 4) { // text or CDATA
    return xml.nodeValue.trim();
  }

  // Process children
  if (xml.hasChildNodes()) {
    let hasElementChildren = false;
    let textContent = "";
    for (let i = 0; i < xml.childNodes.length; i++) {
      let item = xml.childNodes.item(i);
      if (item.nodeType === 1) { // Element node
        hasElementChildren = true;
        let nodeName = item.nodeName;
        if (typeof obj[nodeName] == "undefined") {
          obj[nodeName] = xmlToJsonSimplified(item);
        } else {
          if (typeof obj[nodeName].push == "undefined") {
            let old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(xmlToJsonSimplified(item));
        }
      } else if (item.nodeType === 3 || item.nodeType === 4) { // Text or CDATA node
        textContent += item.nodeValue.trim();
      }
    }

    if (!hasElementChildren && textContent) {
      // If only text content and no child elements, return text directly
      return textContent;
    } else if (textContent) {
      // If there are both text and element children, add text as a special property
      obj["#text"] = textContent;
    }
  }

  return obj;
}

export function rgbToHex(colorStr, fallback = '#465DAE') {
  if (!colorStr || typeof colorStr !== 'string') return fallback;
  const str = colorStr.trim();

  // If already a valid 6-char hex code (#RRGGBB)
  if (/^#([0-9a-fA-F]{6})$/i.test(str)) {
    return str.toUpperCase();
  }

  // If 3-char hex code (#RGB)
  if (/^#([0-9a-fA-F]{3})$/i.test(str)) {
    const hex = str.slice(1).split('').map(c => c + c).join('');
    return `#${hex}`.toUpperCase();
  }

  // If 8-char hex code with alpha (#RRGGBBAA)
  if (/^#([0-9a-fA-F]{8})$/i.test(str)) {
    return str.substring(0, 7).toUpperCase();
  }

  // If rgb(...) or rgba(...) format
  const rgbaMatch = str.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (rgbaMatch) {
    const [, r, g, b] = rgbaMatch;
    const hexR = Math.min(255, parseInt(r, 10)).toString(16).padStart(2, '0');
    const hexG = Math.min(255, parseInt(g, 10)).toString(16).padStart(2, '0');
    const hexB = Math.min(255, parseInt(b, 10)).toString(16).padStart(2, '0');
    return `#${hexR}${hexG}${hexB}`.toUpperCase();
  }

  // If 6 hex characters without '#'
  if (/^[0-9a-fA-F]{6}$/i.test(str)) {
    return `#${str}`.toUpperCase();
  }

  return fallback;
}

/**
 * Derives 2-letter avatar initials from an Auth0 user ID or name string.
 * Example: "auth0|6650abc..." -> "66" or "AK"
 */
export const getInitials = (sub = '') => {
    if (!sub) return '??';
    const clean = sub.includes('|') ? sub.split('|')[1] : sub;
    return (clean || '??').slice(0, 2).toUpperCase();
};